<template>
  <div class="breadcrumbs">
    <div class="breadcrumbs__wrapper">
      <button
        v-if="searchQuery && searchQuery !== ''"
        class="breadcrumbs__clear-search"
        @click="emptySearchQuery()"
      >
        {{ searchQuery }}
        <span class="breadcrumbs__clear-search-icon">X</span>
      </button>
      <ais-current-refinements
        :class-names="{
          'ais-CurrentRefinements-category': 'breadcrumbs__category',
          'ais-CurrentRefinements-list': 'breadcrumbs__list',
          'ais-CurrentRefinements-item': 'breadcrumbs__item',
          'ais-CurrentRefinements-label': 'breadcrumbs__label',
          'ais-CurrentRefinements-delete': 'breadcrumbs__delete',
        }"
      >
      </ais-current-refinements>
    </div>
    <div class="breadcrumbs__toggles-wrapper">
      <Toggles :viewStyle="viewStyle" />
    </div>
  </div>
</template>

<script>
import Toggles from '@/components/search/search-components/Toggles.vue'

export default {
  name: 'Breadcrumbs',
  components: {
    Toggles,
  },
  props: {
    searchQuery: {
      type: String,
      required: true,
    },
    viewStyle: {
      type: String,
      required: true,
    },
  },
  methods: {
    emptySearchQuery() {
      this.$store.dispatch('search/setSearchQuery', '')
    },
  },
}
</script>

<style lang="scss">
.breadcrumbs {
  position: absolute;
  top: -40px;
  width: 100%;
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--flat-black);
  padding: 0 0 10px 0;
  &__wrapper {
    display: none;
    @include tablet {
      display: flex;
      align-items: center;
    }
  }
  &__toggles-wrapper {
    margin: 0 0 0 auto;
  }
  &__clear-search {
    background: var(--light-gray);
    color: var(--white);
    border: none;
    border-radius: 25px;
    font-size: 0.8rem;
    padding: 4px 25px;
    display: flex;
    align-items: center;
  }
  &__clear-search-icon {
    font-size: 0.7rem;
    font-weight: 700;
    color: var(--black);
    background: var(--orange);
    padding: 0px 5px;
    border-radius: 100%;
    margin: 0 -20px 0 15px;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
  }
  &__category {
    background: var(--light-gray);
    color: var(--white);
    border-radius: 25px;
    padding: 4px 25px;
    margin: 0 10px;
    display: flex;
    align-items: center;
    font-size: 0.8rem;
  }
  &__item {
    color: var(--white);
    display: flex;
    align-items: center;
  }
  &__label {
    display: none;
  }
  &__delete {
    background: var(--orange);
    color: var(--black);
    border: none;
    border-radius: 100%;
    padding: 0px 4px;
    font-size: 0.7rem;
    font-weight: 700;
    margin: 0 -20px 0 20px;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
}
</style>
